export enum EUserRole {
    Blocked = 7,
    Unverified = 8,
    ThirdPartyUser = 9,
    User = 10,
    Manager = 50,
    SuperAdmin = 100,
}